import React, { useState } from "react";
import { QrBlock } from "../../../../shared/ui/QrBlock";
import { useAppSelector } from "../../../../shared/store";
import { sendVerification } from "../../../../shared/store/payment/api";
import { OverlayLoader } from "../../../../shared/ui/OverlayLoader";
import { FileInput } from "../../../../shared/ui/FileInput";
import styles from "./index.module.scss";

export const PaymentCancelVideoReport = ({
  attachFile,
  descriptionText = true,
  operatorComment,
}: {
  attachFile: boolean;
  descriptionText?: boolean;
  operatorComment?: string;
}) => {
  const offerData = useAppSelector((state) => state.payment.offer);
  const [file, setFile] = useState<File | null>(null);
  const [isFileCorrect, setFileCorrect] = useState(true);
  const [isVoluntaryConfirmed, setIsVoluntaryConfirmed] = useState(false);
  const [isSending, setIsSending] = useState(false);

  const handleSubmit = async () => {
    if (!offerData || !file) return;
    setIsSending(true);
    await sendVerification(file, offerData.id, "", "");
    setIsSending(false);
  };

  if (!offerData) return null;

  const canSubmit = !!file && isVoluntaryConfirmed;

  return (
    <div className={styles.wrapper}>
      {isSending && <OverlayLoader />}

      <div className={styles.card}>
        {operatorComment && (
          <div className={styles.operatorNote}>
            <p className={styles.operatorNote_title}>Комментарий оператора</p>
            <p className={styles.operatorNote_text}>{operatorComment}</p>
          </div>
        )}

        <div className={styles.statusIcon} aria-hidden="true" />

        <h1 className={styles.title}>Чек не прошел проверку!</h1>

        <div className={styles.subtitle}>
          Номер заказа <strong>{offerData.humanId}</strong>
        </div>

        {descriptionText && (
          <div className={styles.details}>
            <div className={styles.detailRow}>
              <span className={styles.detailLabel}>Оплата на:</span>
              <span className={styles.detailValue}>
                {offerData.cardNumber} {offerData.phoneNumber} ({offerData.providerName})
              </span>
            </div>
            <div className={styles.detailRow}>
              <span className={styles.detailLabel}>Сумма:</span>
              <span className={styles.detailValue}>
                {offerData.amountFiat} {offerData.fiatCode}
              </span>
            </div>
            <div className={styles.detailRow}>
              <span className={styles.detailLabel}>Тип сделки:</span>
              <span className={styles.detailValue}>P2P обмен</span>
            </div>
          </div>
        )}

        <div className={styles.noticeCompact}>
          <p className={styles.noticeCompact_title}>
            ❗ <strong>Подтверждение:</strong> загружая видео, вы подтверждаете, что перевод выполнен вами{" "}
            <span className={styles.emphasis}>
              самостоятельно, добровольно и без указаний со стороны третьих лиц.
            </span>
          </p>
          <p className={styles.noticeCompact_sub}>
            <strong>Предупреждение:</strong> если записать или отправить это видео вас попросил другой
            человек, не делайте этого и прекратите перевод. Такое видео может быть использовано для
            обмана и безвозвратной потери средств.
          </p>
        </div>

        <div className={styles.consentBox}>
          <label className={styles.consentLabel}>
            <input
              type="checkbox"
              checked={isVoluntaryConfirmed}
              onChange={(e) => setIsVoluntaryConfirmed(e.target.checked)}
              className={styles.consentCheckbox}
            />
            <span>
              Я подтверждаю, что выполняю перевод самостоятельно, добровольно и без указаний со
              стороны третьих лиц.
            </span>
          </label>
          <div className={styles.consentHint}>
            Пожалуйста, коротко проговорите это в начале видео если есть такая возможность, это
            ускорит проверку вашего платежа!
          </div>
        </div>

        <p className={styles.lead}>
          Загрузите одно видео, где одновременно видны платеж в онлайн-банке и платежная форма на
          этой странице.
        </p>

        {attachFile && (
          <FileInput
            file={file}
            setFile={setFile}
            isFileCorrect={isFileCorrect}
            setFileCorrect={setFileCorrect}
            placeholder="В начале видео коротко подтвердите добровольность перевода"
            accept="video/mp4,video/mkv,video/x-m4v,video/*"
            signatures={[]}
            warn="Необходимо загрузить видео файл"
          />
        )}

        <div className={styles.alertWarning}>
          <strong>Важно:</strong> видео без платежной формы не принимается к обработке!
        </div>

        {attachFile && (
          <button
            className={styles.btnPrimary}
            type="button"
            disabled={!canSubmit || isSending}
            onClick={handleSubmit}
          >
            Отправить видео на проверку
          </button>
        )}

        <div className={styles.helper}>
          Для быстрой и точной проверки покажите на видео эту страницу от начала до самого конца,
          иначе проверка может быть не пройдена!
        </div>
      </div>

      <QrBlock />
    </div>
  );
};
